import expresslogo from '../../../../assets/images/xpress-shipping.gif';

const ExpressDelivery = (props) => {
  //debugger;
  let { shippingAmt, width, expressType } = props;
  shippingAmt = parseInt(shippingAmt, 10);

  if (expressType && expressType === '2') {
    //Super Express
    return (
      <span>
        <img
          src="fastDelivery.svg"
          style={{ width: '76px' }}
          alt="Express Delivery"
        />
      </span>
    );
  } else if (shippingAmt > 0) {
    return (
      <span>
        <img
          src={expresslogo}
          style={{ width: width }}
          alt="Express Delivery"
        ></img>
      </span>
    );
  } else {
    return null;
  }
};

export default ExpressDelivery;
